import { makeStyles } from 'tss-react/mui';

import LAYOUT_SIZES from 'constants/styles/LAYOUT_SIZES';

type StyleParams = {
  isHeaderVisible: boolean;
};

const useStyles = makeStyles<StyleParams>()((theme, { isHeaderVisible }) => ({
  header: {
    backgroundColor: theme.palette.primary.main,
    position: 'absolute',
    left: '0',
    top: '0',
    zIndex: 100,
    width: '100vw',
    padding: theme.spacing(2, 3),
    height: LAYOUT_SIZES.HEADER.md,
    boxShadow: theme.shadows[2],
    transform: `translateY(${isHeaderVisible ? 0 : '-105%'})`,
    transition: `transform 400ms`,

    [theme.breakpoints.down('md')]: {
      height: LAYOUT_SIZES.HEADER.sm,
    },
  },
  content: {
    maxWidth: LAYOUT_SIZES.CONTAINER.MAIN,
    width: '100%',
    height: '100%',
    padding: theme.spacing(0, 6),
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '250px auto 250px',

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 2),
      gridTemplateColumns: '100px auto 100px',
    },

    '@media(max-width: 400px)': {
      gridTemplateColumns: 'auto 1fr',
    },
  },
  gridCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoLink: {
    // theme.spacing() already returns values with `px`
    height: `calc(${LAYOUT_SIZES.HEADER.md}px - ${theme.spacing(7)})`,
    alignSelf: 'center',

    [theme.breakpoints.down('md')]: {
      height: `calc(${LAYOUT_SIZES.HEADER.sm}px - ${theme.spacing(6)})`,
    },

    '@media(max-width: 400px)': {
      display: 'none',
    },
  },
  logo: {
    height: '100%',
    width: 'auto',
    display: 'block',
    marginBottom: 0,
  },
  location: {
    color: theme.palette.common.white,
    userSelect: 'none',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,

    [theme.breakpoints.down('md')]: {
      fontSize: '0.875rem',
    },
  },
  purchaseButton: {
    height: `calc(${LAYOUT_SIZES.HEADER.md}px - ${theme.spacing(9)})`,
    marginRight: theme.spacing(5),
    whiteSpace: 'nowrap',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  menuButtonContainer: {
    border: 'none',
    background: 'none',
    marginLeft: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',

    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(2),
    },
  },
  menuButton: {
    height: `calc(${LAYOUT_SIZES.HEADER.md}px - ${theme.spacing(8)})`,
    width: `calc(${LAYOUT_SIZES.HEADER.md}px - ${theme.spacing(8)})`,
    display: 'block',
  },
  contentGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    alignSelf: 'center',
    height: `calc(${LAYOUT_SIZES.HEADER.md}px - ${theme.spacing(12)})`,
  },
}));

export default useStyles;
